/**
 * MonitorIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MonitorIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M18.599 2.104A3.473 3.473 0 0 1 21.9 5.571v8.857l-.005.17a3.47 3.47 0 0 1-3.295 3.297l-.171.005h-3.41l.275 2.2h.562l.092.005a.9.9 0 0 1 0 1.79l-.092.005H8.143a.901.901 0 0 1 0-1.8h.563l.274-2.2H5.571A3.473 3.473 0 0 1 2.1 14.43V5.57A3.473 3.473 0 0 1 5.57 2.1h12.857zM10.519 20.1h2.961l-.274-2.2h-2.412zM3.9 14.429a1.67 1.67 0 0 0 1.671 1.67H18.43l.164-.007a1.67 1.67 0 0 0 1.507-1.663V13.9H3.9zM5.571 3.9a1.67 1.67 0 0 0-1.67 1.671V12.1H20.1V5.57a1.67 1.67 0 0 0-1.032-1.544 1.7 1.7 0 0 0-.64-.127z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MonitorIcon = makeIcon('MonitorIcon', MonitorIconSvg)
